import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import LoginPageInput from "../../../components/LoginPage/LoginPageInput";
import { getLoginPageDataById } from "../../../utils/ApiCalls/LoginPage";

const EditLoginPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [slider, setSlider] = useState(null);

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Login Page List", route: "/website/webpages/login-page" },
    { title: "Edit Login Page", route: `/website/webpages/login-page/edit/${id}` },
  ];

  useEffect(() => {
    fetchSlider();
  }, [id]);

  const fetchSlider = async () => {
    const res = await getLoginPageDataById(id);
    if (res) {
      setSlider(res);
    }
  };

  if (!slider) return null;

  return (
    <Layout type={"update_per"} module_data={"login-page"}>
      <CustomHeaderTitle title={"Edit Login Page Slider Images"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Login Page Slider Images"}
      />
      <LoginPageInput slider={slider} />
    </Layout>
  );
};

export default EditLoginPage;
